import { Fragment } from "react";
import { Badge } from "../../ui/badge";
import { STATUS, TYPE } from "./feedback-model";

export function StatusBadge({ status }: { status: string }) {
  const [l, t] = STATUS[status] ?? [status, ""];
  return <Badge tone={t}>{l}</Badge>;
}

export function TypeBadge({ type }: { type: string }) {
  const [l, t] = TYPE[type] ?? [type, ""];
  return <Badge tone={t}>{l}</Badge>;
}

/** Zeilenumbrüche eines fremden Textes als `<br/>` — ohne HTML aus der Zeichenkette. */
export function Lines({ text }: { text: string }) {
  const parts = text.split("\n");
  return <>{parts.map((p, i) => <Fragment key={i}>{i ? <br /> : null}{p}</Fragment>)}</>;
}
